import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { editCategory } from "../api";

export const useEditCategory = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: editCategory,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["CATEGORY"] });
      router("/category");
      toast.success("Success Create Category");
    },
  });

  return { edit: mutate, isPending };
};
